export default {
  id: null,
  tipo: null,
  grupoID: null,
  contaID: null,
  permissoesUsadas: null
}



// WEBPACK FOOTER //
// ./src/shared/models/access/permissionmodel.js